import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'order-status',
  name: '案件进度',
  icon: '案',
  group: '公证组件',
  description: '展示公证案件状态和待办。',
  defaultProps: {
    title: '案件进度',
    limit: 5
}
}
